import { Icon, Stack, Tag, Text, Tooltip } from '@chakra-ui/react';
import { HiCheck, HiXMark } from 'react-icons/hi2';

type Props = {
  isMatch: boolean;
  help: string;
  /** Names what was compared, beside the tag; it takes the surrounding text colour. */
  label: string;
};

export const MatchTag = ({ isMatch, help, label }: Props) => (
  <Stack direction="row" align="center" spacing={1} flexShrink={0}>
    <Text textStyle="bodySmallRegular">{label}</Text>
    <Tooltip label={help}>
      <Tag size="sm" colorScheme={isMatch ? 'green' : 'red'}>
        <Icon as={isMatch ? HiCheck : HiXMark} />
      </Tag>
    </Tooltip>
  </Stack>
);
